export default __webpack_public_path__ + "static/media/Make-a-Claim.1c0a6998.svg";